import FilterAltIcon from '@mui/icons-material/FilterAlt'
import {
  Box,
  Checkbox,
  IconButton,
  ListItemText,
  MenuItem,
  Paper,
  Popper,
  Select,
} from '@mui/material'
import { useState } from 'react'

import { SUBTYPE_OPTIONS } from '../constants.ts'

export const SubtypeFilterHeader = ({
  value,
  onChange,
}: {
  value: string[] | undefined
  onChange: (val: string[] | undefined) => void
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const selected = value ?? []

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ fontWeight: 600 }}>Product</span>
      </Box>
      <Box
        sx={{
          ml: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconButton
          size="small"
          onClick={e => {
            e.stopPropagation()
            setAnchorEl(prev => (prev ? null : e.currentTarget))
          }}
          sx={{
            p: 0.25,
            color: selected.length > 0 ? 'primary.main' : 'action.active',
          }}
        >
          <FilterAltIcon fontSize="small" />
        </IconButton>
      </Box>
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="bottom-start"
        sx={{ zIndex: 'modal' }}
      >
        <Paper
          elevation={8}
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mt: 0.5,
          }}
        >
          <Select
            multiple
            value={selected}
            onChange={e => {
              const val = e.target.value
              const next = typeof val === 'string' ? val.split(',') : val
              onChange(next.length > 0 ? next : undefined)
            }}
            renderValue={vals =>
              vals.length === 0
                ? 'All'
                : vals
                    .map(val => SUBTYPE_OPTIONS.find(option => option.value === val)?.label ?? val)
                    .join(', ')
            }
            displayEmpty
            size="small"
            sx={{ minWidth: 160 }}
          >
            {SUBTYPE_OPTIONS.map(option => (
              <MenuItem key={option.value} value={option.value}>
                <Checkbox checked={selected.includes(option.value)} size="small" />
                <ListItemText primary={option.label} />
              </MenuItem>
            ))}
          </Select>
        </Paper>
      </Popper>
    </Box>
  )
}
